module.exports = __webpack_public_path__ + "static/img/fullscreen-image_subscribe_600.9bcf8f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/fullscreen-image_subscribe_600.png
// module id = VSup
// module chunks = 0